import { Link } from 'react-router-dom';
import { SUPPORT_EMAIL } from '../lib/support';
import { heading, lead, panel, sectionTitle } from '../lib/ui';

/**
 * おといあわせ（#260、ADR-032 A1）。保護者の方と利用者の方が、運営に連絡できる先を出す。
 *
 * **App Store Connect のサポート URL にこのページを入れる**（`https://drawgon.app/support`）。公開前の Basic 認証が
 * かかっていると Apple から読めないので、審査に出す前に本番の認証を外す（プライバシーポリシーと同じ）。
 *
 * まだできていないこと（アプリの「しらせる」は #264）を、できるように書かない。
 */
export function Support() {
  return (
    <div className="space-y-6 pt-4">
      <h1 className={heading}>おといあわせ</h1>
      <p className={lead}>
        drawgon
        についてのお問い合わせは、下のメールアドレスで受け付けています。保護者の方からのご相談も、こちらへお送りください。
      </p>

      <section className={panel}>
        <h2 className={sectionTitle}>メールアドレス</h2>
        <p className="mt-3 font-display text-xl">
          <a href={`mailto:${SUPPORT_EMAIL}`} className="underline decoration-2 underline-offset-4">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <p className={`${lead} mt-2 text-sm`}>届いた順にお返事します。</p>
      </section>

      <section className={panel}>
        <h2 className={sectionTitle}>こんなときに</h2>
        <ul className={`${lead} mt-3 list-disc space-y-2 pl-5`}>
          <li>
            アプリの中で、ほかの人の絵や名前に、いやな言葉・見せてはいけないもの・名前や学校名などが入っているのを見つけたとき
          </li>
          <li>アカウントやデータの消しかた、データの引き継ぎについて</li>
          <li>AI 鑑定に送った絵や、集める情報の扱いについて</li>
        </ul>
        <p className={`${lead} mt-3`}>
          情報の扱いは
          <Link to="/privacy" className="text-text underline decoration-2 underline-offset-4">
            プライバシーポリシー
          </Link>
          に書いています。
        </p>
      </section>
    </div>
  );
}
